import { render } from "./header-five.vue?vue&type=template&id=956ab44e"
import script from "./header-five.vue?vue&type=script&lang=js"
export * from "./header-five.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__